import { BiHelpCircle, BiSupport } from "react-icons/bi";
import { MdLeaderboard } from "react-icons/md";
import { FiUserPlus } from "react-icons/fi";
import { IoAlertCircle } from "react-icons/io5";
import { FaTrophy } from "react-icons/fa";
import { GiPresent } from "react-icons/gi";

export interface INavLink {
  name: string;
  path: string;
  icon: React.ReactNode;
  isNew?: boolean;
}

export const navLinks: INavLink[] = [
  {
    name: "Home",
    path: "/app/home",
    icon: (
      <svg
        width="18"
        height="25"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.06055 8.53524L9.11461 1.16016L17.1687 8.53524L17.1687 19.0711H12.1349V14.8567C12.1349 14.0184 11.8167 13.2145 11.2503 12.6217C10.6838 12.029 9.91563 11.696 9.11461 11.696C8.31358 11.696 7.54536 12.029 6.97895 12.6217C6.41254 13.2145 6.09434 14.0184 6.09434 14.8567V19.0711H1.06055L1.06055 8.53524Z"
          stroke="currentColor"
          stroke-width="1.51014"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   name: 'Bitcoin Wallet',
  //   path: '/app/bitcoin-wallet',
  //   icon: (
  //     <svg
  //       width='25'
  //       height='25'
  //       viewBox='0 0 25 25'
  //       fill='none'
  //       xmlns='http://www.w3.org/2000/svg'
  //     >
  //       <path
  //         fill-rule='evenodd'
  //         clip-rule='evenodd'
  //         d='M5.59675 5.28357C5.39649 5.28357 5.20443 5.36312 5.06283 5.50473C4.92123 5.64633 4.84168 5.83838 4.84168 6.03864C4.84168 6.2389 4.92123 6.43095 5.06283 6.57255C5.20443 6.71416 5.39649 6.79371 5.59675 6.79371H20.6981C21.0986 6.79371 21.4827 6.95281 21.7659 7.23602C22.0491 7.51922 22.2082 7.90333 22.2082 8.30384V18.8748C22.2082 19.2753 22.0491 19.6594 21.7659 19.9426C21.4827 20.2258 21.0986 20.3849 20.6981 20.3849H5.59675C4.99598 20.3849 4.41981 20.1463 3.99501 19.7215C3.5702 19.2967 3.33154 18.7205 3.33154 18.1197V6.03864C3.33154 5.43787 3.5702 4.86171 3.99501 4.4369C4.41981 4.01209 4.99598 3.77344 5.59675 3.77344H18.4329C18.8499 3.77344 19.188 4.11149 19.188 4.52851C19.188 4.94552 18.8499 5.28357 18.4329 5.28357H5.59675ZM4.84168 8.17429V18.1197C4.84168 18.32 4.92123 18.512 5.06283 18.6536C5.20443 18.7952 5.39649 18.8748 5.59675 18.8748H20.6981V8.30384H5.59675C5.33705 8.30384 5.08194 8.25925 4.84168 8.17429Z'
  //         fill='currentColor'
  //       />
  //       <path
  //         d='M17.3001 14.7261C17.9256 14.7261 18.4327 14.2191 18.4327 13.5935C18.4327 12.968 17.9256 12.4609 17.3001 12.4609C16.6746 12.4609 16.1675 12.968 16.1675 13.5935C16.1675 14.2191 16.6746 14.7261 17.3001 14.7261Z'
  //         fill='currentColor'
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "USDT Wallet",
    path: "/app/usdt-wallet",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.59675 5.28357C5.39649 5.28357 5.20443 5.36312 5.06283 5.50473C4.92123 5.64633 4.84168 5.83838 4.84168 6.03864C4.84168 6.2389 4.92123 6.43095 5.06283 6.57255C5.20443 6.71416 5.39649 6.79371 5.59675 6.79371H20.6981C21.0986 6.79371 21.4827 6.95281 21.7659 7.23602C22.0491 7.51922 22.2082 7.90333 22.2082 8.30384V18.8748C22.2082 19.2753 22.0491 19.6594 21.7659 19.9426C21.4827 20.2258 21.0986 20.3849 20.6981 20.3849H5.59675C4.99598 20.3849 4.41981 20.1463 3.99501 19.7215C3.5702 19.2967 3.33154 18.7205 3.33154 18.1197V6.03864C3.33154 5.43787 3.5702 4.86171 3.99501 4.4369C4.41981 4.01209 4.99598 3.77344 5.59675 3.77344H18.4329C18.8499 3.77344 19.188 4.11149 19.188 4.52851C19.188 4.94552 18.8499 5.28357 18.4329 5.28357H5.59675ZM4.84168 8.17429V18.1197C4.84168 18.32 4.92123 18.512 5.06283 18.6536C5.20443 18.7952 5.39649 18.8748 5.59675 18.8748H20.6981V8.30384H5.59675C5.33705 8.30384 5.08194 8.25925 4.84168 8.17429Z"
          fill="currentColor"
        />
        <path
          d="M17.3001 14.7261C17.9256 14.7261 18.4327 14.2191 18.4327 13.5935C18.4327 12.968 17.9256 12.4609 17.3001 12.4609C16.6746 12.4609 16.1675 12.968 16.1675 13.5935C16.1675 14.2191 16.6746 14.7261 17.3001 14.7261Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Giftcard",
    path: "/app/giftcard?page=1",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.73828 8.30701C2.73828 7.47299 3.41439 6.79688 4.24842 6.79688H20.8599C21.6939 6.79688 22.37 7.47299 22.37 8.30701V11.3273C22.37 12.1613 21.6939 12.8374 20.8599 12.8374H4.24842C3.41439 12.8374 2.73828 12.1613 2.73828 11.3273V8.30701ZM20.8599 8.30701H4.24842V11.3273H20.8599V8.30701Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.0036 11.3242C5.42062 11.3242 5.75867 11.6623 5.75867 12.0793V18.8749H19.3499V12.0793C19.3499 11.6623 19.6879 11.3242 20.105 11.3242C20.522 11.3242 20.86 11.6623 20.86 12.0793V18.8749C20.86 19.2754 20.7009 19.6595 20.4177 19.9427C20.1345 20.2259 19.7504 20.385 19.3499 20.385H5.75867C5.35816 20.385 4.97405 20.2259 4.69084 19.9427C4.40764 19.6595 4.24854 19.2754 4.24854 18.8749V12.0793C4.24854 11.6623 4.58659 11.3242 5.0036 11.3242Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5544 6.79688C12.9714 6.79688 13.3095 7.13493 13.3095 7.55194V19.633C13.3095 20.05 12.9714 20.3881 12.5544 20.3881C12.1374 20.3881 11.7993 20.05 11.7993 19.633V7.55194C11.7993 7.13493 12.1374 6.79688 12.5544 6.79688Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1561 3.80781C14.0092 3.95662 13.8555 4.23028 13.7209 4.63527C13.5902 5.02848 13.4982 5.48117 13.4352 5.92307C13.3922 6.22416 13.3639 6.51173 13.3452 6.75995C13.5934 6.74124 13.8809 6.71286 14.182 6.6699C14.6239 6.60686 15.0766 6.51493 15.4698 6.38424C15.8748 6.24964 16.1485 6.09592 16.2973 5.949C16.5805 5.66518 16.7395 5.28062 16.7395 4.87967C16.7395 4.47811 16.58 4.093 16.296 3.80906C16.0121 3.52512 15.627 3.3656 15.2254 3.3656C14.8245 3.3656 14.4399 3.52465 14.1561 3.80781ZM16.83 6.48419L17.3639 7.0181C17.931 6.45095 18.2496 5.68174 18.2496 4.87967C18.2496 4.0776 17.931 3.30838 17.3639 2.74124C16.7967 2.17409 16.0275 1.85547 15.2254 1.85547C14.4234 1.85547 13.6542 2.17409 13.087 2.74124L13.0847 2.74359C12.6986 3.13303 12.4528 3.66245 12.2878 4.15899C12.1185 4.66833 12.0105 5.21728 11.9402 5.70977C11.8695 6.20525 11.8345 6.66219 11.817 6.9943C11.8083 7.16093 11.8038 7.29755 11.8016 7.39358C11.8005 7.44163 11.7999 7.47962 11.7996 7.50623L11.7994 7.53747L11.7993 7.5464L11.7993 7.54915L11.7993 7.55008C11.7993 7.55023 11.7993 7.55072 12.5544 7.55072L11.7993 7.55008C11.7993 7.75034 11.8789 7.94303 12.0205 8.08463C12.1621 8.22624 12.3541 8.30579 12.5544 8.30579V7.55072C12.5544 8.30579 12.5542 8.30579 12.5544 8.30579L12.556 8.30579L12.5587 8.30578L12.5676 8.30574L12.5989 8.30548C12.6255 8.30519 12.6635 8.30462 12.7115 8.3035C12.8076 8.30127 12.9442 8.29685 13.1108 8.28808C13.4429 8.27061 13.8999 8.23559 14.3953 8.1649C14.8878 8.09463 15.4368 7.98659 15.9461 7.81731C16.4427 7.65228 16.9721 7.40647 17.3615 7.02045L16.83 6.48419Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.74465 2.74124C8.3118 2.17409 9.08102 1.85547 9.88309 1.85547C10.6852 1.85547 11.4544 2.17409 12.0215 2.74124L12.0239 2.74359C12.4099 3.13303 12.6557 3.66245 12.8207 4.15899C12.99 4.66833 13.0981 5.21728 13.1683 5.70977C13.239 6.20525 13.274 6.66219 13.2915 6.9943C13.3003 7.16093 13.3047 7.29755 13.3069 7.39358C13.308 7.44163 13.3086 7.47962 13.3089 7.50623L13.3092 7.53747L13.3092 7.5464L13.3092 7.54915L13.3092 7.55008C13.3092 7.55023 13.3092 7.55072 12.5541 7.55072C12.5541 8.30579 12.554 8.30579 12.5539 8.30579L12.5526 8.30579L12.5498 8.30578L12.5409 8.30574L12.5096 8.30548C12.483 8.30519 12.4451 8.30462 12.397 8.3035C12.301 8.30127 12.1643 8.29685 11.9977 8.28808C11.6656 8.27061 11.2087 8.23559 10.7132 8.1649C10.2207 8.09463 9.67175 7.98659 9.16241 7.81731C8.66587 7.65228 8.13645 7.40647 7.74701 7.02045L8.27857 6.48419L7.74465 7.0181C7.17751 6.45095 6.85889 5.68174 6.85889 4.87967C6.85889 4.0776 7.17751 3.30838 7.74465 2.74124ZM8.81121 5.949C8.96 6.09592 9.23368 6.24964 9.63869 6.38424C10.0319 6.51493 10.4846 6.60686 10.9265 6.6699C11.2276 6.71286 11.5151 6.74124 11.7634 6.75995C11.7447 6.51173 11.7163 6.22416 11.6733 5.92307C11.6103 5.48117 11.5183 5.02848 11.3877 4.63527C11.2531 4.23026 11.0993 3.95659 10.9524 3.80779C10.6686 3.52464 10.284 3.3656 9.88309 3.3656C9.48153 3.3656 9.09642 3.52512 8.81248 3.80906C8.52854 4.093 8.36902 4.47811 8.36902 4.87967C8.36902 5.28062 8.52806 5.66518 8.81121 5.949ZM12.5541 7.55072L12.5539 8.30579C12.7541 8.30579 12.9464 8.22624 13.0881 8.08463C13.2297 7.94303 13.3092 7.75034 13.3092 7.55008L12.5541 7.55072Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Transaction",
    path: "/app/transaction",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.0332 12.8371C4.0332 12.4201 4.37126 12.082 4.78827 12.082H10.0737C10.4908 12.082 10.8288 12.4201 10.8288 12.8371C10.8288 13.2541 10.4908 13.5922 10.0737 13.5922H5.54334V19.6327C5.54334 20.0497 5.20528 20.3878 4.78827 20.3878C4.37126 20.3878 4.0332 20.0497 4.0332 19.6327V12.8371Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.52295 19.6301C2.52295 19.2131 2.861 18.875 3.27802 18.875H22.1547C22.5717 18.875 22.9098 19.2131 22.9098 19.6301C22.9098 20.0471 22.5717 20.3851 22.1547 20.3851H3.27802C2.861 20.3851 2.52295 20.0471 2.52295 19.6301Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.31836 8.30585C9.31836 7.88884 9.65641 7.55078 10.0734 7.55078H15.3589C15.7759 7.55078 16.114 7.88884 16.114 8.30585C16.114 8.72286 15.7759 9.06092 15.3589 9.06092H10.8285V19.6319C10.8285 20.0489 10.4904 20.3869 10.0734 20.3869C9.65641 20.3869 9.31836 20.0489 9.31836 19.6319V8.30585Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.604 3.7746C14.604 3.35759 14.9421 3.01953 15.3591 3.01953H20.6445C21.0616 3.01953 21.3996 3.35759 21.3996 3.7746V19.631C21.3996 20.048 21.0616 20.3861 20.6445 20.3861H15.3591C14.9421 20.3861 14.604 20.048 14.604 19.631V3.7746ZM16.1141 4.52967V18.876H19.8895V4.52967H16.1141Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "CRYPTO QUICK SELL",
    path: "/app/quick-sell",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.402 15.8558C16.2208 15.8558 16.0194 15.8457 15.8282 15.8357C15.4557 15.8155 15.1536 15.5135 15.1234 15.141C14.902 12.3321 12.6166 10.0569 9.81782 9.83537C9.44532 9.80517 9.14329 9.50316 9.12315 9.13066C9.11308 8.93937 9.10303 8.74808 9.10303 8.5568C9.10303 4.52977 12.375 1.25781 16.402 1.25781C20.429 1.25781 23.701 4.52977 23.701 8.5568C23.701 12.5838 20.429 15.8558 16.402 15.8558ZM10.6132 8.41584C13.6133 8.93935 16.0195 11.3455 16.543 14.3457C19.674 14.2651 22.1909 11.7079 22.1909 8.5568C22.1909 5.36538 19.5934 2.76795 16.402 2.76795C13.2609 2.76795 10.6937 5.28482 10.6132 8.41584Z"
          fill="currentColor"
        />
        <path
          d="M9.35465 22.9027C5.32762 22.9027 2.05566 19.6307 2.05566 15.6037C2.05566 11.5766 5.32762 8.30469 9.35465 8.30469C9.53587 8.30469 9.73723 8.31474 9.92851 8.32481C13.4824 8.6067 16.3617 11.4861 16.6335 15.0198C16.6436 15.2211 16.6536 15.4124 16.6536 15.6037C16.6536 19.6307 13.3817 22.9027 9.35465 22.9027ZM9.35465 9.81482C6.16323 9.81482 3.5658 12.4123 3.5658 15.6037C3.5658 18.7951 6.16323 21.3925 9.35465 21.3925C12.5461 21.3925 15.1435 18.7951 15.1435 15.6037C15.1435 15.4426 15.1334 15.2815 15.1234 15.1305C14.9019 12.3418 12.6266 10.0564 9.81775 9.83495C9.6768 9.82488 9.51573 9.81482 9.35465 9.81482Z"
          fill="currentColor"
        />
        <path
          d="M3.81749 7.38896C3.58593 7.38896 3.36443 7.34868 3.14295 7.25807C2.47849 6.98625 2.05566 6.34193 2.05566 5.62713V3.01964C2.05566 2.05315 2.851 1.25781 3.81749 1.25781H6.42498C7.13978 1.25781 7.77403 1.68064 8.05593 2.3451C8.32775 3.00956 8.17673 3.76463 7.67335 4.26801L5.06586 6.8755C4.72356 7.20773 4.2806 7.38896 3.81749 7.38896ZM3.81749 2.76795C3.67654 2.76795 3.5658 2.87869 3.5658 3.01964V5.62713C3.5658 5.77815 3.66647 5.83856 3.71681 5.8587C3.77721 5.87883 3.88797 5.90902 3.98865 5.80834L6.59615 3.20085C6.69682 3.10017 6.67668 2.98944 6.64647 2.92903C6.61627 2.86863 6.55585 2.77803 6.41491 2.77803H3.81749V2.76795Z"
          fill="currentColor"
        />
        <path
          d="M21.9393 22.9033H19.3318C18.617 22.9033 17.9828 22.4805 17.7009 21.816C17.4291 21.1515 17.5801 20.3965 18.0835 19.8931L20.6909 17.2856C21.1943 16.7822 21.9494 16.6312 22.6139 16.903C23.2783 17.1749 23.7011 17.8192 23.7011 18.534V21.1415C23.7011 22.108 22.9058 22.9033 21.9393 22.9033ZM21.9292 18.2823C21.8789 18.2823 21.8185 18.3024 21.7581 18.3628L19.1506 20.9703C19.0499 21.071 19.0701 21.1817 19.1003 21.2421C19.1305 21.3026 19.1909 21.3932 19.3318 21.3932H21.9393C22.0803 21.3932 22.191 21.2824 22.191 21.1415V18.534C22.191 18.383 22.0903 18.3225 22.04 18.3024C22.0098 18.2923 21.9695 18.2823 21.9292 18.2823Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Bills",
    path: "/app/bills",
    isNew: true,
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.8333 4.16667H4.16667C3.05208 4.16667 2.08333 5.13542 2.08333 6.25V18.75C2.08333 19.8646 3.05208 20.8333 4.16667 20.8333H20.8333C21.9479 20.8333 22.9167 19.8646 22.9167 18.75V6.25C22.9167 5.13542 21.9479 4.16667 20.8333 4.16667Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29167 8.33333H17.7083"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29167 12.5H17.7083"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29167 16.6667H12.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Buy Gift Cards",
    path: "/app/buy-giftcards",
    isNew: true,
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2"
          y="5"
          width="21"
          height="15"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M2 10H23"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <circle
          cx="12.5"
          cy="14.5"
          r="2"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M10.5 14.5C10.5 13.12 11.62 12 13 12"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    name: "Chat",
    path: "/app/chat",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.2116 3.81155C11.1946 3.68514 9.20088 4.2993 7.60464 5.53872C6.00839 6.77814 4.91944 8.55759 4.5422 10.543C4.16497 12.5284 4.5254 14.5832 5.55584 16.3217C5.66136 16.4998 5.68918 16.7133 5.6328 16.9124L4.74846 20.0358L7.87188 19.1515L8.07758 19.878L8.46257 19.2285C10.2011 20.2589 12.2559 20.6193 14.2413 20.2421C16.2267 19.8649 18.0062 18.7759 19.2456 17.1797C20.485 15.5834 21.0992 13.5897 20.9728 11.5727C20.8464 9.55572 19.9881 7.65425 18.5591 6.22523C17.1301 4.79622 15.2286 3.93795 13.2116 3.81155ZM7.97875 20.6907C9.97101 21.7829 12.2844 22.1511 14.5232 21.7257C16.87 21.2798 18.9733 19.9926 20.4384 18.1058C21.9034 16.219 22.6293 13.8624 22.4799 11.4782C22.3305 9.09413 21.316 6.84654 19.6269 5.15741C17.9378 3.46828 15.6902 2.45378 13.3061 2.30437C10.9219 2.15496 8.56528 2.88091 6.67848 4.34593C4.79168 5.81096 3.50451 7.9143 3.05861 10.2611C2.63324 12.4999 3.00137 14.8133 4.09356 16.8056L3.29331 19.632C3.21877 19.8893 3.21445 20.1619 3.28085 20.4215C3.34757 20.6823 3.48322 20.9204 3.67358 21.1107C3.86395 21.3011 4.10202 21.4367 4.36283 21.5034C4.62243 21.5699 4.89504 21.5655 5.15236 21.491L7.97875 20.6907Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.6584 10.0376C10.9533 9.74269 11.4314 9.74269 11.7262 10.0376L14.2126 12.5239L16.699 10.0376C16.9938 9.74269 17.4719 9.74269 17.7668 10.0376C18.0617 10.3324 18.0617 10.8105 17.7668 11.1054L14.7465 14.1257C14.4516 14.4205 13.9736 14.4205 13.6787 14.1257L11.1923 11.6393L8.70597 14.1257C8.4111 14.4205 7.93302 14.4205 7.63815 14.1257C7.34327 13.8308 7.34327 13.3527 7.63815 13.0578L10.6584 10.0376Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

export const mobileBottomNavLinks: INavLink[] = [
  {
    name: "Home",
    path: "/app/home",
    icon: (
      <svg
        width="18"
        height="25"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.06055 8.53524L9.11461 1.16016L17.1687 8.53524L17.1687 19.0711H12.1349V14.8567C12.1349 14.0184 11.8167 13.2145 11.2503 12.6217C10.6838 12.029 9.91563 11.696 9.11461 11.696C8.31358 11.696 7.54536 12.029 6.97895 12.6217C6.41254 13.2145 6.09434 14.0184 6.09434 14.8567V19.0711H1.06055L1.06055 8.53524Z"
          stroke="currentColor"
          stroke-width="1.51014"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   name: 'Bitcoin Wallet',
  //   path: '/app/bitcoin-wallet',
  //   icon: (
  //     <svg
  //       width='25'
  //       height='25'
  //       viewBox='0 0 25 25'
  //       fill='none'
  //       xmlns='http://www.w3.org/2000/svg'
  //     >
  //       <path
  //         fill-rule='evenodd'
  //         clip-rule='evenodd'
  //         d='M5.59675 5.28357C5.39649 5.28357 5.20443 5.36312 5.06283 5.50473C4.92123 5.64633 4.84168 5.83838 4.84168 6.03864C4.84168 6.2389 4.92123 6.43095 5.06283 6.57255C5.20443 6.71416 5.39649 6.79371 5.59675 6.79371H20.6981C21.0986 6.79371 21.4827 6.95281 21.7659 7.23602C22.0491 7.51922 22.2082 7.90333 22.2082 8.30384V18.8748C22.2082 19.2753 22.0491 19.6594 21.7659 19.9426C21.4827 20.2258 21.0986 20.3849 20.6981 20.3849H5.59675C4.99598 20.3849 4.41981 20.1463 3.99501 19.7215C3.5702 19.2967 3.33154 18.7205 3.33154 18.1197V6.03864C3.33154 5.43787 3.5702 4.86171 3.99501 4.4369C4.41981 4.01209 4.99598 3.77344 5.59675 3.77344H18.4329C18.8499 3.77344 19.188 4.11149 19.188 4.52851C19.188 4.94552 18.8499 5.28357 18.4329 5.28357H5.59675ZM4.84168 8.17429V18.1197C4.84168 18.32 4.92123 18.512 5.06283 18.6536C5.20443 18.7952 5.39649 18.8748 5.59675 18.8748H20.6981V8.30384H5.59675C5.33705 8.30384 5.08194 8.25925 4.84168 8.17429Z'
  //         fill='currentColor'
  //       />
  //       <path
  //         d='M17.3001 14.7261C17.9256 14.7261 18.4327 14.2191 18.4327 13.5935C18.4327 12.968 17.9256 12.4609 17.3001 12.4609C16.6746 12.4609 16.1675 12.968 16.1675 13.5935C16.1675 14.2191 16.6746 14.7261 17.3001 14.7261Z'
  //         fill='currentColor'
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "Sell Giftcard",
    path: "/app/giftcard?page=1",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.73828 8.30701C2.73828 7.47299 3.41439 6.79688 4.24842 6.79688H20.8599C21.6939 6.79688 22.37 7.47299 22.37 8.30701V11.3273C22.37 12.1613 21.6939 12.8374 20.8599 12.8374H4.24842C3.41439 12.8374 2.73828 12.1613 2.73828 11.3273V8.30701ZM20.8599 8.30701H4.24842V11.3273H20.8599V8.30701Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.0036 11.3242C5.42062 11.3242 5.75867 11.6623 5.75867 12.0793V18.8749H19.3499V12.0793C19.3499 11.6623 19.6879 11.3242 20.105 11.3242C20.522 11.3242 20.86 11.6623 20.86 12.0793V18.8749C20.86 19.2754 20.7009 19.6595 20.4177 19.9427C20.1345 20.2259 19.7504 20.385 19.3499 20.385H5.75867C5.35816 20.385 4.97405 20.2259 4.69084 19.9427C4.40764 19.6595 4.24854 19.2754 4.24854 18.8749V12.0793C4.24854 11.6623 4.58659 11.3242 5.0036 11.3242Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5544 6.79688C12.9714 6.79688 13.3095 7.13493 13.3095 7.55194V19.633C13.3095 20.05 12.9714 20.3881 12.5544 20.3881C12.1374 20.3881 11.7993 20.05 11.7993 19.633V7.55194C11.7993 7.13493 12.1374 6.79688 12.5544 6.79688Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1561 3.80781C14.0092 3.95662 13.8555 4.23028 13.7209 4.63527C13.5902 5.02848 13.4982 5.48117 13.4352 5.92307C13.3922 6.22416 13.3639 6.51173 13.3452 6.75995C13.5934 6.74124 13.8809 6.71286 14.182 6.6699C14.6239 6.60686 15.0766 6.51493 15.4698 6.38424C15.8748 6.24964 16.1485 6.09592 16.2973 5.949C16.5805 5.66518 16.7395 5.28062 16.7395 4.87967C16.7395 4.47811 16.58 4.093 16.296 3.80906C16.0121 3.52512 15.627 3.3656 15.2254 3.3656C14.8245 3.3656 14.4399 3.52465 14.1561 3.80781ZM16.83 6.48419L17.3639 7.0181C17.931 6.45095 18.2496 5.68174 18.2496 4.87967C18.2496 4.0776 17.931 3.30838 17.3639 2.74124C16.7967 2.17409 16.0275 1.85547 15.2254 1.85547C14.4234 1.85547 13.6542 2.17409 13.087 2.74124L13.0847 2.74359C12.6986 3.13303 12.4528 3.66245 12.2878 4.15899C12.1185 4.66833 12.0105 5.21728 11.9402 5.70977C11.8695 6.20525 11.8345 6.66219 11.817 6.9943C11.8083 7.16093 11.8038 7.29755 11.8016 7.39358C11.8005 7.44163 11.7999 7.47962 11.7996 7.50623L11.7994 7.53747L11.7993 7.5464L11.7993 7.54915L11.7993 7.55008C11.7993 7.55023 11.7993 7.55072 12.5544 7.55072L11.7993 7.55008C11.7993 7.75034 11.8789 7.94303 12.0205 8.08463C12.1621 8.22624 12.3541 8.30579 12.5544 8.30579V7.55072C12.5544 8.30579 12.5542 8.30579 12.5544 8.30579L12.556 8.30579L12.5587 8.30578L12.5676 8.30574L12.5989 8.30548C12.6255 8.30519 12.6635 8.30462 12.7115 8.3035C12.8076 8.30127 12.9442 8.29685 13.1108 8.28808C13.4429 8.27061 13.8999 8.23559 14.3953 8.1649C14.8878 8.09463 15.4368 7.98659 15.9461 7.81731C16.4427 7.65228 16.9721 7.40647 17.3615 7.02045L16.83 6.48419Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.74465 2.74124C8.3118 2.17409 9.08102 1.85547 9.88309 1.85547C10.6852 1.85547 11.4544 2.17409 12.0215 2.74124L12.0239 2.74359C12.4099 3.13303 12.6557 3.66245 12.8207 4.15899C12.99 4.66833 13.0981 5.21728 13.1683 5.70977C13.239 6.20525 13.274 6.66219 13.2915 6.9943C13.3003 7.16093 13.3047 7.29755 13.3069 7.39358C13.308 7.44163 13.3086 7.47962 13.3089 7.50623L13.3092 7.53747L13.3092 7.5464L13.3092 7.54915L13.3092 7.55008C13.3092 7.55023 13.3092 7.55072 12.5541 7.55072C12.5541 8.30579 12.554 8.30579 12.5539 8.30579L12.5526 8.30579L12.5498 8.30578L12.5409 8.30574L12.5096 8.30548C12.483 8.30519 12.4451 8.30462 12.397 8.3035C12.301 8.30127 12.1643 8.29685 11.9977 8.28808C11.6656 8.27061 11.2087 8.23559 10.7132 8.1649C10.2207 8.09463 9.67175 7.98659 9.16241 7.81731C8.66587 7.65228 8.13645 7.40647 7.74701 7.02045L8.27857 6.48419L7.74465 7.0181C7.17751 6.45095 6.85889 5.68174 6.85889 4.87967C6.85889 4.0776 7.17751 3.30838 7.74465 2.74124ZM8.81121 5.949C8.96 6.09592 9.23368 6.24964 9.63869 6.38424C10.0319 6.51493 10.4846 6.60686 10.9265 6.6699C11.2276 6.71286 11.5151 6.74124 11.7634 6.75995C11.7447 6.51173 11.7163 6.22416 11.6733 5.92307C11.6103 5.48117 11.5183 5.02848 11.3877 4.63527C11.2531 4.23026 11.0993 3.95659 10.9524 3.80779C10.6686 3.52464 10.284 3.3656 9.88309 3.3656C9.48153 3.3656 9.09642 3.52512 8.81248 3.80906C8.52854 4.093 8.36902 4.47811 8.36902 4.87967C8.36902 5.28062 8.52806 5.66518 8.81121 5.949ZM12.5541 7.55072L12.5539 8.30579C12.7541 8.30579 12.9464 8.22624 13.0881 8.08463C13.2297 7.94303 13.3092 7.75034 13.3092 7.55008L12.5541 7.55072Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Buy Giftcard",
    path: "/app/buy-giftcards",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.73828 8.30701C2.73828 7.47299 3.41439 6.79688 4.24842 6.79688H20.8599C21.6939 6.79688 22.37 7.47299 22.37 8.30701V11.3273C22.37 12.1613 21.6939 12.8374 20.8599 12.8374H4.24842C3.41439 12.8374 2.73828 12.1613 2.73828 11.3273V8.30701ZM20.8599 8.30701H4.24842V11.3273H20.8599V8.30701Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.0036 11.3242C5.42062 11.3242 5.75867 11.6623 5.75867 12.0793V18.8749H19.3499V12.0793C19.3499 11.6623 19.6879 11.3242 20.105 11.3242C20.522 11.3242 20.86 11.6623 20.86 12.0793V18.8749C20.86 19.2754 20.7009 19.6595 20.4177 19.9427C20.1345 20.2259 19.7504 20.385 19.3499 20.385H5.75867C5.35816 20.385 4.97405 20.2259 4.69084 19.9427C4.40764 19.6595 4.24854 19.2754 4.24854 18.8749V12.0793C4.24854 11.6623 4.58659 11.3242 5.0036 11.3242Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5544 6.79688C12.9714 6.79688 13.3095 7.13493 13.3095 7.55194V19.633C13.3095 20.05 12.9714 20.3881 12.5544 20.3881C12.1374 20.3881 11.7993 20.05 11.7993 19.633V7.55194C11.7993 7.13493 12.1374 6.79688 12.5544 6.79688Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1561 3.80781C14.0092 3.95662 13.8555 4.23028 13.7209 4.63527C13.5902 5.02848 13.4982 5.48117 13.4352 5.92307C13.3922 6.22416 13.3639 6.51173 13.3452 6.75995C13.5934 6.74124 13.8809 6.71286 14.182 6.6699C14.6239 6.60686 15.0766 6.51493 15.4698 6.38424C15.8748 6.24964 16.1485 6.09592 16.2973 5.949C16.5805 5.66518 16.7395 5.28062 16.7395 4.87967C16.7395 4.47811 16.58 4.093 16.296 3.80906C16.0121 3.52512 15.627 3.3656 15.2254 3.3656C14.8245 3.3656 14.4399 3.52465 14.1561 3.80781ZM16.83 6.48419L17.3639 7.0181C17.931 6.45095 18.2496 5.68174 18.2496 4.87967C18.2496 4.0776 17.931 3.30838 17.3639 2.74124C16.7967 2.17409 16.0275 1.85547 15.2254 1.85547C14.4234 1.85547 13.6542 2.17409 13.087 2.74124L13.0847 2.74359C12.6986 3.13303 12.4528 3.66245 12.2878 4.15899C12.1185 4.66833 12.0105 5.21728 11.9402 5.70977C11.8695 6.20525 11.8345 6.66219 11.817 6.9943C11.8083 7.16093 11.8038 7.29755 11.8016 7.39358C11.8005 7.44163 11.7999 7.47962 11.7996 7.50623L11.7994 7.53747L11.7993 7.5464L11.7993 7.54915L11.7993 7.55008C11.7993 7.55023 11.7993 7.55072 12.5544 7.55072L11.7993 7.55008C11.7993 7.75034 11.8789 7.94303 12.0205 8.08463C12.1621 8.22624 12.3541 8.30579 12.5544 8.30579V7.55072C12.5544 8.30579 12.5542 8.30579 12.5544 8.30579L12.556 8.30579L12.5587 8.30578L12.5676 8.30574L12.5989 8.30548C12.6255 8.30519 12.6635 8.30462 12.7115 8.3035C12.8076 8.30127 12.9442 8.29685 13.1108 8.28808C13.4429 8.27061 13.8999 8.23559 14.3953 8.1649C14.8878 8.09463 15.4368 7.98659 15.9461 7.81731C16.4427 7.65228 16.9721 7.40647 17.3615 7.02045L16.83 6.48419Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.74465 2.74124C8.3118 2.17409 9.08102 1.85547 9.88309 1.85547C10.6852 1.85547 11.4544 2.17409 12.0215 2.74124L12.0239 2.74359C12.4099 3.13303 12.6557 3.66245 12.8207 4.15899C12.99 4.66833 13.0981 5.21728 13.1683 5.70977C13.239 6.20525 13.274 6.66219 13.2915 6.9943C13.3003 7.16093 13.3047 7.29755 13.3069 7.39358C13.308 7.44163 13.3086 7.47962 13.3089 7.50623L13.3092 7.53747L13.3092 7.5464L13.3092 7.54915L13.3092 7.55008C13.3092 7.55023 13.3092 7.55072 12.5541 7.55072C12.5541 8.30579 12.554 8.30579 12.5539 8.30579L12.5526 8.30579L12.5498 8.30578L12.5409 8.30574L12.5096 8.30548C12.483 8.30519 12.4451 8.30462 12.397 8.3035C12.301 8.30127 12.1643 8.29685 11.9977 8.28808C11.6656 8.27061 11.2087 8.23559 10.7132 8.1649C10.2207 8.09463 9.67175 7.98659 9.16241 7.81731C8.66587 7.65228 8.13645 7.40647 7.74701 7.02045L8.27857 6.48419L7.74465 7.0181C7.17751 6.45095 6.85889 5.68174 6.85889 4.87967C6.85889 4.0776 7.17751 3.30838 7.74465 2.74124ZM8.81121 5.949C8.96 6.09592 9.23368 6.24964 9.63869 6.38424C10.0319 6.51493 10.4846 6.60686 10.9265 6.6699C11.2276 6.71286 11.5151 6.74124 11.7634 6.75995C11.7447 6.51173 11.7163 6.22416 11.6733 5.92307C11.6103 5.48117 11.5183 5.02848 11.3877 4.63527C11.2531 4.23026 11.0993 3.95659 10.9524 3.80779C10.6686 3.52464 10.284 3.3656 9.88309 3.3656C9.48153 3.3656 9.09642 3.52512 8.81248 3.80906C8.52854 4.093 8.36902 4.47811 8.36902 4.87967C8.36902 5.28062 8.52806 5.66518 8.81121 5.949ZM12.5541 7.55072L12.5539 8.30579C12.7541 8.30579 12.9464 8.22624 13.0881 8.08463C13.2297 7.94303 13.3092 7.75034 13.3092 7.55008L12.5541 7.55072Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Chat",
    path: "/app/chat",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.2116 3.81155C11.1946 3.68514 9.20088 4.2993 7.60464 5.53872C6.00839 6.77814 4.91944 8.55759 4.5422 10.543C4.16497 12.5284 4.5254 14.5832 5.55584 16.3217C5.66136 16.4998 5.68918 16.7133 5.6328 16.9124L4.74846 20.0358L7.87188 19.1515L8.07758 19.878L8.46257 19.2285C10.2011 20.2589 12.2559 20.6193 14.2413 20.2421C16.2267 19.8649 18.0062 18.7759 19.2456 17.1797C20.485 15.5834 21.0992 13.5897 20.9728 11.5727C20.8464 9.55572 19.9881 7.65425 18.5591 6.22523C17.1301 4.79622 15.2286 3.93795 13.2116 3.81155ZM7.97875 20.6907C9.97101 21.7829 12.2844 22.1511 14.5232 21.7257C16.87 21.2798 18.9733 19.9926 20.4384 18.1058C21.9034 16.219 22.6293 13.8624 22.4799 11.4782C22.3305 9.09413 21.316 6.84654 19.6269 5.15741C17.9378 3.46828 15.6902 2.45378 13.3061 2.30437C10.9219 2.15496 8.56528 2.88091 6.67848 4.34593C4.79168 5.81096 3.50451 7.9143 3.05861 10.2611C2.63324 12.4999 3.00137 14.8133 4.09356 16.8056L3.29331 19.632C3.21877 19.8893 3.21445 20.1619 3.28085 20.4215C3.34757 20.6823 3.48322 20.9204 3.67358 21.1107C3.86395 21.3011 4.10202 21.4367 4.36283 21.5034C4.62243 21.5699 4.89504 21.5655 5.15236 21.491L7.97875 20.6907Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.6584 10.0376C10.9533 9.74269 11.4314 9.74269 11.7262 10.0376L14.2126 12.5239L16.699 10.0376C16.9938 9.74269 17.4719 9.74269 17.7668 10.0376C18.0617 10.3324 18.0617 10.8105 17.7668 11.1054L14.7465 14.1257C14.4516 14.4205 13.9736 14.4205 13.6787 14.1257L11.1923 11.6393L8.70597 14.1257C8.4111 14.4205 7.93302 14.4205 7.63815 14.1257C7.34327 13.8308 7.34327 13.3527 7.63815 13.0578L10.6584 10.0376Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Account",
    path: "/app/account",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.6147 3.77576C9.69561 3.77576 7.32923 6.14215 7.32923 9.06123C7.32923 11.9803 9.69561 14.3467 12.6147 14.3467C15.5338 14.3467 17.9002 11.9803 17.9002 9.06123C17.9002 6.14215 15.5338 3.77576 12.6147 3.77576ZM5.81909 9.06123C5.81909 5.30812 8.86159 2.26562 12.6147 2.26562C16.3678 2.26562 19.4103 5.30812 19.4103 9.06123C19.4103 12.8143 16.3678 15.8568 12.6147 15.8568C8.86159 15.8568 5.81909 12.8143 5.81909 9.06123Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.615 15.8578C10.8918 15.8578 9.19894 16.3114 7.70665 17.1731C6.21435 18.0348 4.97519 19.2741 4.11373 20.7665C3.90525 21.1277 3.44347 21.2515 3.08231 21.043C2.72115 20.8345 2.59737 20.3727 2.80584 20.0116C3.79984 18.2896 5.22964 16.8595 6.95152 15.8653C8.6734 14.8711 10.6267 14.3477 12.615 14.3477C14.6033 14.3477 16.5566 14.8711 18.2784 15.8653C20.0003 16.8595 21.4301 18.2896 22.4241 20.0116C22.6326 20.3727 22.5088 20.8345 22.1476 21.043C21.7865 21.2515 21.3247 21.1277 21.1162 20.7665C20.2548 19.2741 19.0156 18.0348 17.5233 17.1731C16.031 16.3114 14.3382 15.8578 12.615 15.8578Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
];

export const mobileNavLinks: INavLink[] = [
  {
    name: "Home",
    path: "/app/home",
    icon: (
      <svg
        width="18"
        height="25"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.06055 8.53524L9.11461 1.16016L17.1687 8.53524L17.1687 19.0711H12.1349V14.8567C12.1349 14.0184 11.8167 13.2145 11.2503 12.6217C10.6838 12.029 9.91563 11.696 9.11461 11.696C8.31358 11.696 7.54536 12.029 6.97895 12.6217C6.41254 13.2145 6.09434 14.0184 6.09434 14.8567V19.0711H1.06055L1.06055 8.53524Z"
          stroke="currentColor"
          stroke-width="1.51014"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   name: 'Bitcoin Wallet',
  //   path: '/app/bitcoin-wallet',
  //   icon: (
  //     <svg
  //       width='25'
  //       height='25'
  //       viewBox='0 0 25 25'
  //       fill='none'
  //       xmlns='http://www.w3.org/2000/svg'
  //     >
  //       <path
  //         fill-rule='evenodd'
  //         clip-rule='evenodd'
  //         d='M5.59675 5.28357C5.39649 5.28357 5.20443 5.36312 5.06283 5.50473C4.92123 5.64633 4.84168 5.83838 4.84168 6.03864C4.84168 6.2389 4.92123 6.43095 5.06283 6.57255C5.20443 6.71416 5.39649 6.79371 5.59675 6.79371H20.6981C21.0986 6.79371 21.4827 6.95281 21.7659 7.23602C22.0491 7.51922 22.2082 7.90333 22.2082 8.30384V18.8748C22.2082 19.2753 22.0491 19.6594 21.7659 19.9426C21.4827 20.2258 21.0986 20.3849 20.6981 20.3849H5.59675C4.99598 20.3849 4.41981 20.1463 3.99501 19.7215C3.5702 19.2967 3.33154 18.7205 3.33154 18.1197V6.03864C3.33154 5.43787 3.5702 4.86171 3.99501 4.4369C4.41981 4.01209 4.99598 3.77344 5.59675 3.77344H18.4329C18.8499 3.77344 19.188 4.11149 19.188 4.52851C19.188 4.94552 18.8499 5.28357 18.4329 5.28357H5.59675ZM4.84168 8.17429V18.1197C4.84168 18.32 4.92123 18.512 5.06283 18.6536C5.20443 18.7952 5.39649 18.8748 5.59675 18.8748H20.6981V8.30384H5.59675C5.33705 8.30384 5.08194 8.25925 4.84168 8.17429Z'
  //         fill='currentColor'
  //       />
  //       <path
  //         d='M17.3001 14.7261C17.9256 14.7261 18.4327 14.2191 18.4327 13.5935C18.4327 12.968 17.9256 12.4609 17.3001 12.4609C16.6746 12.4609 16.1675 12.968 16.1675 13.5935C16.1675 14.2191 16.6746 14.7261 17.3001 14.7261Z'
  //         fill='currentColor'
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "Sell Giftcard",
    path: "/app/giftcard",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.73828 8.30701C2.73828 7.47299 3.41439 6.79688 4.24842 6.79688H20.8599C21.6939 6.79688 22.37 7.47299 22.37 8.30701V11.3273C22.37 12.1613 21.6939 12.8374 20.8599 12.8374H4.24842C3.41439 12.8374 2.73828 12.1613 2.73828 11.3273V8.30701ZM20.8599 8.30701H4.24842V11.3273H20.8599V8.30701Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.0036 11.3242C5.42062 11.3242 5.75867 11.6623 5.75867 12.0793V18.8749H19.3499V12.0793C19.3499 11.6623 19.6879 11.3242 20.105 11.3242C20.522 11.3242 20.86 11.6623 20.86 12.0793V18.8749C20.86 19.2754 20.7009 19.6595 20.4177 19.9427C20.1345 20.2259 19.7504 20.385 19.3499 20.385H5.75867C5.35816 20.385 4.97405 20.2259 4.69084 19.9427C4.40764 19.6595 4.24854 19.2754 4.24854 18.8749V12.0793C4.24854 11.6623 4.58659 11.3242 5.0036 11.3242Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5544 6.79688C12.9714 6.79688 13.3095 7.13493 13.3095 7.55194V19.633C13.3095 20.05 12.9714 20.3881 12.5544 20.3881C12.1374 20.3881 11.7993 20.05 11.7993 19.633V7.55194C11.7993 7.13493 12.1374 6.79688 12.5544 6.79688Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1561 3.80781C14.0092 3.95662 13.8555 4.23028 13.7209 4.63527C13.5902 5.02848 13.4982 5.48117 13.4352 5.92307C13.3922 6.22416 13.3639 6.51173 13.3452 6.75995C13.5934 6.74124 13.8809 6.71286 14.182 6.6699C14.6239 6.60686 15.0766 6.51493 15.4698 6.38424C15.8748 6.24964 16.1485 6.09592 16.2973 5.949C16.5805 5.66518 16.7395 5.28062 16.7395 4.87967C16.7395 4.47811 16.58 4.093 16.296 3.80906C16.0121 3.52512 15.627 3.3656 15.2254 3.3656C14.8245 3.3656 14.4399 3.52465 14.1561 3.80781ZM16.83 6.48419L17.3639 7.0181C17.931 6.45095 18.2496 5.68174 18.2496 4.87967C18.2496 4.0776 17.931 3.30838 17.3639 2.74124C16.7967 2.17409 16.0275 1.85547 15.2254 1.85547C14.4234 1.85547 13.6542 2.17409 13.087 2.74124L13.0847 2.74359C12.6986 3.13303 12.4528 3.66245 12.2878 4.15899C12.1185 4.66833 12.0105 5.21728 11.9402 5.70977C11.8695 6.20525 11.8345 6.66219 11.817 6.9943C11.8083 7.16093 11.8038 7.29755 11.8016 7.39358C11.8005 7.44163 11.7999 7.47962 11.7996 7.50623L11.7994 7.53747L11.7993 7.5464L11.7993 7.54915L11.7993 7.55008C11.7993 7.55023 11.7993 7.55072 12.5544 7.55072L11.7993 7.55008C11.7993 7.75034 11.8789 7.94303 12.0205 8.08463C12.1621 8.22624 12.3541 8.30579 12.5544 8.30579V7.55072C12.5544 8.30579 12.5542 8.30579 12.5544 8.30579L12.556 8.30579L12.5587 8.30578L12.5676 8.30574L12.5989 8.30548C12.6255 8.30519 12.6635 8.30462 12.7115 8.3035C12.8076 8.30127 12.9442 8.29685 13.1108 8.28808C13.4429 8.27061 13.8999 8.23559 14.3953 8.1649C14.8878 8.09463 15.4368 7.98659 15.9461 7.81731C16.4427 7.65228 16.9721 7.40647 17.3615 7.02045L16.83 6.48419Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.74465 2.74124C8.3118 2.17409 9.08102 1.85547 9.88309 1.85547C10.6852 1.85547 11.4544 2.17409 12.0215 2.74124L12.0239 2.74359C12.4099 3.13303 12.6557 3.66245 12.8207 4.15899C12.99 4.66833 13.0981 5.21728 13.1683 5.70977C13.239 6.20525 13.274 6.66219 13.2915 6.9943C13.3003 7.16093 13.3047 7.29755 13.3069 7.39358C13.308 7.44163 13.3086 7.47962 13.3089 7.50623L13.3092 7.53747L13.3092 7.5464L13.3092 7.54915L13.3092 7.55008C13.3092 7.55023 13.3092 7.55072 12.5541 7.55072C12.5541 8.30579 12.554 8.30579 12.5539 8.30579L12.5526 8.30579L12.5498 8.30578L12.5409 8.30574L12.5096 8.30548C12.483 8.30519 12.4451 8.30462 12.397 8.3035C12.301 8.30127 12.1643 8.29685 11.9977 8.28808C11.6656 8.27061 11.2087 8.23559 10.7132 8.1649C10.2207 8.09463 9.67175 7.98659 9.16241 7.81731C8.66587 7.65228 8.13645 7.40647 7.74701 7.02045L8.27857 6.48419L7.74465 7.0181C7.17751 6.45095 6.85889 5.68174 6.85889 4.87967C6.85889 4.0776 7.17751 3.30838 7.74465 2.74124ZM8.81121 5.949C8.96 6.09592 9.23368 6.24964 9.63869 6.38424C10.0319 6.51493 10.4846 6.60686 10.9265 6.6699C11.2276 6.71286 11.5151 6.74124 11.7634 6.75995C11.7447 6.51173 11.7163 6.22416 11.6733 5.92307C11.6103 5.48117 11.5183 5.02848 11.3877 4.63527C11.2531 4.23026 11.0993 3.95659 10.9524 3.80779C10.6686 3.52464 10.284 3.3656 9.88309 3.3656C9.48153 3.3656 9.09642 3.52512 8.81248 3.80906C8.52854 4.093 8.36902 4.47811 8.36902 4.87967C8.36902 5.28062 8.52806 5.66518 8.81121 5.949ZM12.5541 7.55072L12.5539 8.30579C12.7541 8.30579 12.9464 8.22624 13.0881 8.08463C13.2297 7.94303 13.3092 7.75034 13.3092 7.55008L12.5541 7.55072Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Buy Giftcard",
    path: "/app/buy-giftcards",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.73828 8.30701C2.73828 7.47299 3.41439 6.79688 4.24842 6.79688H20.8599C21.6939 6.79688 22.37 7.47299 22.37 8.30701V11.3273C22.37 12.1613 21.6939 12.8374 20.8599 12.8374H4.24842C3.41439 12.8374 2.73828 12.1613 2.73828 11.3273V8.30701ZM20.8599 8.30701H4.24842V11.3273H20.8599V8.30701Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.0036 11.3242C5.42062 11.3242 5.75867 11.6623 5.75867 12.0793V18.8749H19.3499V12.0793C19.3499 11.6623 19.6879 11.3242 20.105 11.3242C20.522 11.3242 20.86 11.6623 20.86 12.0793V18.8749C20.86 19.2754 20.7009 19.6595 20.4177 19.9427C20.1345 20.2259 19.7504 20.385 19.3499 20.385H5.75867C5.35816 20.385 4.97405 20.2259 4.69084 19.9427C4.40764 19.6595 4.24854 19.2754 4.24854 18.8749V12.0793C4.24854 11.6623 4.58659 11.3242 5.0036 11.3242Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5544 6.79688C12.9714 6.79688 13.3095 7.13493 13.3095 7.55194V19.633C13.3095 20.05 12.9714 20.3881 12.5544 20.3881C12.1374 20.3881 11.7993 20.05 11.7993 19.633V7.55194C11.7993 7.13493 12.1374 6.79688 12.5544 6.79688Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1561 3.80781C14.0092 3.95662 13.8555 4.23028 13.7209 4.63527C13.5902 5.02848 13.4982 5.48117 13.4352 5.92307C13.3922 6.22416 13.3639 6.51173 13.3452 6.75995C13.5934 6.74124 13.8809 6.71286 14.182 6.6699C14.6239 6.60686 15.0766 6.51493 15.4698 6.38424C15.8748 6.24964 16.1485 6.09592 16.2973 5.949C16.5805 5.66518 16.7395 5.28062 16.7395 4.87967C16.7395 4.47811 16.58 4.093 16.296 3.80906C16.0121 3.52512 15.627 3.3656 15.2254 3.3656C14.8245 3.3656 14.4399 3.52465 14.1561 3.80781ZM16.83 6.48419L17.3639 7.0181C17.931 6.45095 18.2496 5.68174 18.2496 4.87967C18.2496 4.0776 17.931 3.30838 17.3639 2.74124C16.7967 2.17409 16.0275 1.85547 15.2254 1.85547C14.4234 1.85547 13.6542 2.17409 13.087 2.74124L13.0847 2.74359C12.6986 3.13303 12.4528 3.66245 12.2878 4.15899C12.1185 4.66833 12.0105 5.21728 11.9402 5.70977C11.8695 6.20525 11.8345 6.66219 11.817 6.9943C11.8083 7.16093 11.8038 7.29755 11.8016 7.39358C11.8005 7.44163 11.7999 7.47962 11.7996 7.50623L11.7994 7.53747L11.7993 7.5464L11.7993 7.54915L11.7993 7.55008C11.7993 7.55023 11.7993 7.55072 12.5544 7.55072L11.7993 7.55008C11.7993 7.75034 11.8789 7.94303 12.0205 8.08463C12.1621 8.22624 12.3541 8.30579 12.5544 8.30579V7.55072C12.5544 8.30579 12.5542 8.30579 12.5544 8.30579L12.556 8.30579L12.5587 8.30578L12.5676 8.30574L12.5989 8.30548C12.6255 8.30519 12.6635 8.30462 12.7115 8.3035C12.8076 8.30127 12.9442 8.29685 13.1108 8.28808C13.4429 8.27061 13.8999 8.23559 14.3953 8.1649C14.8878 8.09463 15.4368 7.98659 15.9461 7.81731C16.4427 7.65228 16.9721 7.40647 17.3615 7.02045L16.83 6.48419Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.74465 2.74124C8.3118 2.17409 9.08102 1.85547 9.88309 1.85547C10.6852 1.85547 11.4544 2.17409 12.0215 2.74124L12.0239 2.74359C12.4099 3.13303 12.6557 3.66245 12.8207 4.15899C12.99 4.66833 13.0981 5.21728 13.1683 5.70977C13.239 6.20525 13.274 6.66219 13.2915 6.9943C13.3003 7.16093 13.3047 7.29755 13.3069 7.39358C13.308 7.44163 13.3086 7.47962 13.3089 7.50623L13.3092 7.53747L13.3092 7.5464L13.3092 7.54915L13.3092 7.55008C13.3092 7.55023 13.3092 7.55072 12.5541 7.55072C12.5541 8.30579 12.554 8.30579 12.5539 8.30579L12.5526 8.30579L12.5498 8.30578L12.5409 8.30574L12.5096 8.30548C12.483 8.30519 12.4451 8.30462 12.397 8.3035C12.301 8.30127 12.1643 8.29685 11.9977 8.28808C11.6656 8.27061 11.2087 8.23559 10.7132 8.1649C10.2207 8.09463 9.67175 7.98659 9.16241 7.81731C8.66587 7.65228 8.13645 7.40647 7.74701 7.02045L8.27857 6.48419L7.74465 7.0181C7.17751 6.45095 6.85889 5.68174 6.85889 4.87967C6.85889 4.0776 7.17751 3.30838 7.74465 2.74124ZM8.81121 5.949C8.96 6.09592 9.23368 6.24964 9.63869 6.38424C10.0319 6.51493 10.4846 6.60686 10.9265 6.6699C11.2276 6.71286 11.5151 6.74124 11.7634 6.75995C11.7447 6.51173 11.7163 6.22416 11.6733 5.92307C11.6103 5.48117 11.5183 5.02848 11.3877 4.63527C11.2531 4.23026 11.0993 3.95659 10.9524 3.80779C10.6686 3.52464 10.284 3.3656 9.88309 3.3656C9.48153 3.3656 9.09642 3.52512 8.81248 3.80906C8.52854 4.093 8.36902 4.47811 8.36902 4.87967C8.36902 5.28062 8.52806 5.66518 8.81121 5.949ZM12.5541 7.55072L12.5539 8.30579C12.7541 8.30579 12.9464 8.22624 13.0881 8.08463C13.2297 7.94303 13.3092 7.75034 13.3092 7.55008L12.5541 7.55072Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "CRYPTO QUICK SELL",
    path: "/app/quick-sell",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.402 15.8558C16.2208 15.8558 16.0194 15.8457 15.8282 15.8357C15.4557 15.8155 15.1536 15.5135 15.1234 15.141C14.902 12.3321 12.6166 10.0569 9.81782 9.83537C9.44532 9.80517 9.14329 9.50316 9.12315 9.13066C9.11308 8.93937 9.10303 8.74808 9.10303 8.5568C9.10303 4.52977 12.375 1.25781 16.402 1.25781C20.429 1.25781 23.701 4.52977 23.701 8.5568C23.701 12.5838 20.429 15.8558 16.402 15.8558ZM10.6132 8.41584C13.6133 8.93935 16.0195 11.3455 16.543 14.3457C19.674 14.2651 22.1909 11.7079 22.1909 8.5568C22.1909 5.36538 19.5934 2.76795 16.402 2.76795C13.2609 2.76795 10.6937 5.28482 10.6132 8.41584Z"
          fill="currentColor"
        />
        <path
          d="M9.35465 22.9027C5.32762 22.9027 2.05566 19.6307 2.05566 15.6037C2.05566 11.5766 5.32762 8.30469 9.35465 8.30469C9.53587 8.30469 9.73723 8.31474 9.92851 8.32481C13.4824 8.6067 16.3617 11.4861 16.6335 15.0198C16.6436 15.2211 16.6536 15.4124 16.6536 15.6037C16.6536 19.6307 13.3817 22.9027 9.35465 22.9027ZM9.35465 9.81482C6.16323 9.81482 3.5658 12.4123 3.5658 15.6037C3.5658 18.7951 6.16323 21.3925 9.35465 21.3925C12.5461 21.3925 15.1435 18.7951 15.1435 15.6037C15.1435 15.4426 15.1334 15.2815 15.1234 15.1305C14.9019 12.3418 12.6266 10.0564 9.81775 9.83495C9.6768 9.82488 9.51573 9.81482 9.35465 9.81482Z"
          fill="currentColor"
        />
        <path
          d="M3.81749 7.38896C3.58593 7.38896 3.36443 7.34868 3.14295 7.25807C2.47849 6.98625 2.05566 6.34193 2.05566 5.62713V3.01964C2.05566 2.05315 2.851 1.25781 3.81749 1.25781H6.42498C7.13978 1.25781 7.77403 1.68064 8.05593 2.3451C8.32775 3.00956 8.17673 3.76463 7.67335 4.26801L5.06586 6.8755C4.72356 7.20773 4.2806 7.38896 3.81749 7.38896ZM3.81749 2.76795C3.67654 2.76795 3.5658 2.87869 3.5658 3.01964V5.62713C3.5658 5.77815 3.66647 5.83856 3.71681 5.8587C3.77721 5.87883 3.88797 5.90902 3.98865 5.80834L6.59615 3.20085C6.69682 3.10017 6.67668 2.98944 6.64647 2.92903C6.61627 2.86863 6.55585 2.77803 6.41491 2.77803H3.81749V2.76795Z"
          fill="currentColor"
        />
        <path
          d="M21.9393 22.9033H19.3318C18.617 22.9033 17.9828 22.4805 17.7009 21.816C17.4291 21.1515 17.5801 20.3965 18.0835 19.8931L20.6909 17.2856C21.1943 16.7822 21.9494 16.6312 22.6139 16.903C23.2783 17.1749 23.7011 17.8192 23.7011 18.534V21.1415C23.7011 22.108 22.9058 22.9033 21.9393 22.9033ZM21.9292 18.2823C21.8789 18.2823 21.8185 18.3024 21.7581 18.3628L19.1506 20.9703C19.0499 21.071 19.0701 21.1817 19.1003 21.2421C19.1305 21.3026 19.1909 21.3932 19.3318 21.3932H21.9393C22.0803 21.3932 22.191 21.2824 22.191 21.1415V18.534C22.191 18.383 22.0903 18.3225 22.04 18.3024C22.0098 18.2923 21.9695 18.2823 21.9292 18.2823Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "USDT Wallet",
    path: "/app/usdt-wallet",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.59675 5.28357C5.39649 5.28357 5.20443 5.36312 5.06283 5.50473C4.92123 5.64633 4.84168 5.83838 4.84168 6.03864C4.84168 6.2389 4.92123 6.43095 5.06283 6.57255C5.20443 6.71416 5.39649 6.79371 5.59675 6.79371H20.6981C21.0986 6.79371 21.4827 6.95281 21.7659 7.23602C22.0491 7.51922 22.2082 7.90333 22.2082 8.30384V18.8748C22.2082 19.2753 22.0491 19.6594 21.7659 19.9426C21.4827 20.2258 21.0986 20.3849 20.6981 20.3849H5.59675C4.99598 20.3849 4.41981 20.1463 3.99501 19.7215C3.5702 19.2967 3.33154 18.7205 3.33154 18.1197V6.03864C3.33154 5.43787 3.5702 4.86171 3.99501 4.4369C4.41981 4.01209 4.99598 3.77344 5.59675 3.77344H18.4329C18.8499 3.77344 19.188 4.11149 19.188 4.52851C19.188 4.94552 18.8499 5.28357 18.4329 5.28357H5.59675ZM4.84168 8.17429V18.1197C4.84168 18.32 4.92123 18.512 5.06283 18.6536C5.20443 18.7952 5.39649 18.8748 5.59675 18.8748H20.6981V8.30384H5.59675C5.33705 8.30384 5.08194 8.25925 4.84168 8.17429Z"
          fill="currentColor"
        />
        <path
          d="M17.3001 14.7261C17.9256 14.7261 18.4327 14.2191 18.4327 13.5935C18.4327 12.968 17.9256 12.4609 17.3001 12.4609C16.6746 12.4609 16.1675 12.968 16.1675 13.5935C16.1675 14.2191 16.6746 14.7261 17.3001 14.7261Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Bills",
    path: "/app/bills",
    isNew: true,
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.8333 4.16667H4.16667C3.05208 4.16667 2.08333 5.13542 2.08333 6.25V18.75C2.08333 19.8646 3.05208 20.8333 4.16667 20.8333H20.8333C21.9479 20.8333 22.9167 19.8646 22.9167 18.75V6.25C22.9167 5.13542 21.9479 4.16667 20.8333 4.16667Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29167 8.33333H17.7083"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29167 12.5H17.7083"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29167 16.6667H12.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   name: 'Trade',
  //   path: '/app/trade',
  //   icon: (
  //     <svg
  //       width='25'
  //       height='25'
  //       viewBox='0 0 25 25'
  //       fill='none'
  //       xmlns='http://www.w3.org/2000/svg'
  //     >
  //       <path
  //         d='M16.402 15.8558C16.2208 15.8558 16.0194 15.8457 15.8282 15.8357C15.4557 15.8155 15.1536 15.5135 15.1234 15.141C14.902 12.3321 12.6166 10.0569 9.81782 9.83537C9.44532 9.80517 9.14329 9.50316 9.12315 9.13066C9.11308 8.93937 9.10303 8.74808 9.10303 8.5568C9.10303 4.52977 12.375 1.25781 16.402 1.25781C20.429 1.25781 23.701 4.52977 23.701 8.5568C23.701 12.5838 20.429 15.8558 16.402 15.8558ZM10.6132 8.41584C13.6133 8.93935 16.0195 11.3455 16.543 14.3457C19.674 14.2651 22.1909 11.7079 22.1909 8.5568C22.1909 5.36538 19.5934 2.76795 16.402 2.76795C13.2609 2.76795 10.6937 5.28482 10.6132 8.41584Z'
  //         fill='currentColor'
  //       />
  //       <path
  //         d='M9.35465 22.9027C5.32762 22.9027 2.05566 19.6307 2.05566 15.6037C2.05566 11.5766 5.32762 8.30469 9.35465 8.30469C9.53587 8.30469 9.73723 8.31474 9.92851 8.32481C13.4824 8.6067 16.3617 11.4861 16.6335 15.0198C16.6436 15.2211 16.6536 15.4124 16.6536 15.6037C16.6536 19.6307 13.3817 22.9027 9.35465 22.9027ZM9.35465 9.81482C6.16323 9.81482 3.5658 12.4123 3.5658 15.6037C3.5658 18.7951 6.16323 21.3925 9.35465 21.3925C12.5461 21.3925 15.1435 18.7951 15.1435 15.6037C15.1435 15.4426 15.1334 15.2815 15.1234 15.1305C14.9019 12.3418 12.6266 10.0564 9.81775 9.83495C9.6768 9.82488 9.51573 9.81482 9.35465 9.81482Z'
  //         fill='currentColor'
  //       />
  //       <path
  //         d='M3.81749 7.38896C3.58593 7.38896 3.36443 7.34868 3.14295 7.25807C2.47849 6.98625 2.05566 6.34193 2.05566 5.62713V3.01964C2.05566 2.05315 2.851 1.25781 3.81749 1.25781H6.42498C7.13978 1.25781 7.77403 1.68064 8.05593 2.3451C8.32775 3.00956 8.17673 3.76463 7.67335 4.26801L5.06586 6.8755C4.72356 7.20773 4.2806 7.38896 3.81749 7.38896ZM3.81749 2.76795C3.67654 2.76795 3.5658 2.87869 3.5658 3.01964V5.62713C3.5658 5.77815 3.66647 5.83856 3.71681 5.8587C3.77721 5.87883 3.88797 5.90902 3.98865 5.80834L6.59615 3.20085C6.69682 3.10017 6.67668 2.98944 6.64647 2.92903C6.61627 2.86863 6.55585 2.77803 6.41491 2.77803H3.81749V2.76795Z'
  //         fill='currentColor'
  //       />
  //       <path
  //         d='M21.9393 22.9033H19.3318C18.617 22.9033 17.9828 22.4805 17.7009 21.816C17.4291 21.1515 17.5801 20.3965 18.0835 19.8931L20.6909 17.2856C21.1943 16.7822 21.9494 16.6312 22.6139 16.903C23.2783 17.1749 23.7011 17.8192 23.7011 18.534V21.1415C23.7011 22.108 22.9058 22.9033 21.9393 22.9033ZM21.9292 18.2823C21.8789 18.2823 21.8185 18.3024 21.7581 18.3628L19.1506 20.9703C19.0499 21.071 19.0701 21.1817 19.1003 21.2421C19.1305 21.3026 19.1909 21.3932 19.3318 21.3932H21.9393C22.0803 21.3932 22.191 21.2824 22.191 21.1415V18.534C22.191 18.383 22.0903 18.3225 22.04 18.3024C22.0098 18.2923 21.9695 18.2823 21.9292 18.2823Z'
  //         fill='currentColor'
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "Help & Support",
    path: "/app/support",
    icon: <BiSupport className="h-6 w-6" />,
  },
  
  {
    name: "Transaction",
    path: "/app/transaction",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.0332 12.8371C4.0332 12.4201 4.37126 12.082 4.78827 12.082H10.0737C10.4908 12.082 10.8288 12.4201 10.8288 12.8371C10.8288 13.2541 10.4908 13.5922 10.0737 13.5922H5.54334V19.6327C5.54334 20.0497 5.20528 20.3878 4.78827 20.3878C4.37126 20.3878 4.0332 20.0497 4.0332 19.6327V12.8371Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.52295 19.6301C2.52295 19.2131 2.861 18.875 3.27802 18.875H22.1547C22.5717 18.875 22.9098 19.2131 22.9098 19.6301C22.9098 20.0471 22.5717 20.3851 22.1547 20.3851H3.27802C2.861 20.3851 2.52295 20.0471 2.52295 19.6301Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.31836 8.30585C9.31836 7.88884 9.65641 7.55078 10.0734 7.55078H15.3589C15.7759 7.55078 16.114 7.88884 16.114 8.30585C16.114 8.72286 15.7759 9.06092 15.3589 9.06092H10.8285V19.6319C10.8285 20.0489 10.4904 20.3869 10.0734 20.3869C9.65641 20.3869 9.31836 20.0489 9.31836 19.6319V8.30585Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.604 3.7746C14.604 3.35759 14.9421 3.01953 15.3591 3.01953H20.6445C21.0616 3.01953 21.3996 3.35759 21.3996 3.7746V19.631C21.3996 20.048 21.0616 20.3861 20.6445 20.3861H15.3591C14.9421 20.3861 14.604 20.048 14.604 19.631V3.7746ZM16.1141 4.52967V18.876H19.8895V4.52967H16.1141Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Withdraw Now",
    path: "/app/withdraw",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.9688 4.26679C13.9688 3.84977 14.3068 3.51172 14.7238 3.51172H20.3868C20.8038 3.51172 21.1419 3.84977 21.1419 4.26679V9.92979C21.1419 10.3468 20.8038 10.6849 20.3868 10.6849C19.9698 10.6849 19.6318 10.3468 19.6318 9.92979V5.02185H14.7238C14.3068 5.02185 13.9688 4.6838 13.9688 4.26679Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.9208 3.73287C21.2156 4.02775 21.2156 4.50583 20.9208 4.8007L14.1252 11.5963C13.8303 11.8912 13.3522 11.8912 13.0573 11.5963C12.7625 11.3014 12.7625 10.8234 13.0573 10.5285L19.8529 3.73287C20.1478 3.438 20.6259 3.438 20.9208 3.73287Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.46257 6.96965C3.74578 6.68645 4.12989 6.52734 4.5304 6.52734H10.5709C10.988 6.52734 11.326 6.8654 11.326 7.28241C11.326 7.69942 10.988 8.03748 10.5709 8.03748L4.5304 8.03748L4.5304 20.1186H16.6115V14.078C16.6115 13.661 16.9495 13.323 17.3665 13.323C17.7836 13.323 18.1216 13.661 18.1216 14.078V20.1186C18.1216 20.5191 17.9625 20.9032 17.6793 21.1864C17.3961 21.4696 17.012 21.6287 16.6115 21.6287H4.5304C4.12989 21.6287 3.74578 21.4696 3.46257 21.1864C3.17937 20.9032 3.02026 20.5191 3.02026 20.1186V8.03748C3.02026 7.63697 3.17937 7.25286 3.46257 6.96965Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Account",
    path: "/app/account",
    icon: (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.081 4.4242C9.16192 4.4242 6.79554 6.79058 6.79554 9.70967C6.79554 12.6288 9.16192 14.9951 12.081 14.9951C15.0001 14.9951 17.3665 12.6288 17.3665 9.70967C17.3665 6.79058 15.0001 4.4242 12.081 4.4242ZM5.2854 9.70967C5.2854 5.95656 8.3279 2.91406 12.081 2.91406C15.8341 2.91406 18.8766 5.95656 18.8766 9.70967C18.8766 13.4628 15.8341 16.5053 12.081 16.5053C8.3279 16.5053 5.2854 13.4628 5.2854 9.70967Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.081 16.5023C10.3578 16.5023 8.66501 16.956 7.17271 17.8176C5.68042 18.6793 4.44125 19.9186 3.57979 21.411C3.37132 21.7722 2.90954 21.896 2.54837 21.6875C2.18721 21.479 2.06343 21.0173 2.27191 20.6561C3.2659 18.9341 4.69571 17.5041 6.41758 16.5098C8.13946 15.5156 10.0927 14.9922 12.081 14.9922C14.0693 14.9922 16.0226 15.5156 17.7445 16.5098C19.4664 17.5041 20.8962 18.9341 21.8902 20.6561C22.0987 21.0173 21.9749 21.479 21.6137 21.6875C21.2525 21.896 20.7908 21.7722 20.5823 21.411C19.7208 19.9186 18.4817 18.6793 16.9894 17.8176C15.4971 16.956 13.8042 16.5023 12.081 16.5023Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    name: "Levels",
    path: "/app/levels",
    icon: <FaTrophy className="text-xl" />,
  },
  {
    name: "Leaderboards",
    path: "/app/leaderboards",
    icon: <MdLeaderboard className="text-xl" />,
  },
  {
    name: "Referrals",
    path: "/app/referrals",
    icon: <FiUserPlus className="text-xl" />,
  },
  {
    name: "Rate Alerts",
    path: "/app/rate-alerts",
    icon: <IoAlertCircle className="text-xl" />,
  },
  {
    name: "TREASURY CHEST",
    path: "/app/treasury-chest",
    icon: <GiPresent className="text-xl" />,
  },
];
